import { fetcher } from '@commenda/utils';

/** A document to attach: an upload, or a stored file named by its id. */
export type TGovernmentIdentifierDocumentRequest = {
  fileUrl: string;
  fileName: string;
  fileId?: number;
};

export type CreateGovernmentIdentifierRequest = {
  /** What the catalog calls the identifier. */
  identifierTypeId?: string;
  value: string;
  supportingDocuments?: TGovernmentIdentifierDocumentRequest[];
  /** The registration it came from, where more than one could have produced it. */
  registrationIdentifier?: string;
};

/**
 * How an identifier names itself to the backend: by its content type. One the content has no
 * type for sends none, and the backend refuses it — it cannot be created.
 */
export const identifierName = (identifier: {
  identifierTypeId?: string | null;
}): { identifierTypeId?: string } =>
  identifier.identifierTypeId
    ? { identifierTypeId: identifier.identifierTypeId }
    : {};

/**
 * What tells one identifier from another in an entity's list: its content type, else its stored
 * row, else its name — the order the backend pairs the list on.
 */
export const identifierIdentity = (identifier: {
  identifierTypeId?: string | null;
  id?: string | null;
  displayName: string;
}): string =>
  identifier.identifierTypeId ?? identifier.id ?? identifier.displayName;

export const createGovernmentIdentifier = async (
  businessEntityId: number,
  body: CreateGovernmentIdentifierRequest
) => {
  const response = await fetcher(
    `business-entities/${businessEntityId}/government-identifiers`,
    { method: 'POST', body }
  );

  return response;
};
